import { ParentComponent } from 'solid-js'

const CardTitle: ParentComponent = (props) => {
  return <h5 class="card-title">
    {props.children}
  </h5>
}

export default CardTitle